module.exports = __webpack_public_path__ + "img/300-thread-count.dfe0011.svg";